import { ILayout } from "common/form/fields/layout/ILayoutType";
import { Form, Input } from "decorator-form";
import InputType from "../../../common/form/InputType";
import { IFragmentLayoutConfig } from "core/components/FragmentLayout";
import TopicComponentConfig from "../component/topic/TopicComponentConfig";
import { topicFormWidget } from "../component/topic/TopicComponentConfig";
import TopicListConfig, { listFormWidget } from "../component/topic/TopicListConfig";
import * as actionFragments from "panels/forum/component/topic/topicActions";
import * as metaFragments from "panels/forum/component/topic/topicMeta";
import { FragmentProvider } from "core/components/FragmentProvider";
import EntitySelect from "../../../common/form/fields/entitySelect/EntitySelect";
import Forum from "../entity/Forum";
import Category from "../entity/Category";

const topicLayout = FragmentProvider.getLayoutInput({...metaFragments, ...actionFragments});

const categorySelect = EntitySelect.registered({entity: Category, type: 'one', getSearchParams:(query)=>({query})}, 'string');

@Form({title: "Topics Panel Config"})
export default class TopicsPanelConfig {

	@Input({type: InputType.JSON, title: "Topic Params"})
	public topicParams: object;

	@Input({type: categorySelect, title: "Category Override"})
	public categoryId: string;

	@Input({type: InputType.CHECKBOX, title: "Enable Refine"})
	public enableRefine?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Enable Load More"})
	public enableLoadMore?: boolean;

	@Input({type: InputType.NUMBER, title: "Default Page Size"})
	public pageSize?: number;

	@Input({type: topicLayout, title: "Layout"})
	public topicLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: listFormWidget, title: "Topic List Options"})
	listConfig: TopicListConfig = new TopicListConfig();

	@Input({type: topicFormWidget, title: "Topic Display"})
	topicConfig: TopicComponentConfig = new TopicComponentConfig();

	@Input({type: InputType.CHECKBOX, title: "Enable Search Bar"})
	public enableSearchBar?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Enable Tag Filter"})
	public enableTagFilter?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Enable Featured Comments"})
	public enableFeaturedTopics?: boolean;

	@Input({ type: InputType.CHECKBOX, title: "Enable permissions filter" })
	public enablePermissionsFilter?: boolean;

}



// WEBPACK FOOTER //
// ./src/panels/forum/config/TopicsPanelConfig.ts